import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../base/tooltip/tooltip";
import { cn } from "../../../utils";
/**
 * A small "ⓘ" affordance that reveals explanatory help on hover/focus. Wraps its
 * own TooltipProvider so it works anywhere (dialogs, tables, forms) without the
 * caller having to supply a provider. Use next to field labels or section
 * headers to explain a concept without crowding the UI.
 */ export function InfoHint({ content, side = "top", label = "Info", className, iconClassName }) {
    return /*#__PURE__*/ _jsx(TooltipProvider, {
        delayDuration: 150,
        children: /*#__PURE__*/ _jsxs(Tooltip, {
            children: [
                /*#__PURE__*/ _jsx(TooltipTrigger, {
                    asChild: true,
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        "aria-label": label,
                        className: cn("inline-flex shrink-0 items-center justify-center text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-full", className),
                        children: /*#__PURE__*/ _jsx(Info, {
                            className: cn("h-3.5 w-3.5", iconClassName)
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(TooltipContent, {
                    side: side,
                    className: "max-w-xs whitespace-normal text-left text-xs font-normal leading-relaxed",
                    children: content
                })
            ]
        })
    });
}

//# sourceMappingURL=info-hint.js.map